<template>
  <b-modal :id="id" @hidden="clean" @ok="confirm" :title="title" :ok-title="button" header-bg-variant="dark" header-text-variant="light" ok-variant="dark">
    <template #modal-title v-if="tool">
      <b-link :href="tool.reference" target="_blank">
        <b-img v-if="tool.icon" :src="tool.icon" width="32"/>
        <b-img v-if="!tool.icon" src="favicon.ico" width="32"/>
      </b-link>
      {{ title }}
    </template>
    <b-form ref="process_form">
      <b-form-group description="Название процесса" :invalid-feedback="invalidName">
        <b-form-input v-model="name" type="text" :state="nameState" maxlength="100" required/>
      </b-form-group>
      <b-form-group :invalid-feedback="invalidDescription">
        <b-form-textarea v-model="description" placeholder="Описание процесса" :state="descriptionState" maxlength="300" required/>
      </b-form-group>
    </b-form>
    <b-form ref="step_form" v-if="tool">
      <b-form-group description="Конфигурация инструмента">
        <b-form-select v-model="configuration" :options="tool.configurations" value-field="id" text-field="name"/>
      </b-form-group>
      <b-form-group>
        <b-input-group :prepend="priority.toString()">
          <b-form-input v-model="priority" type="range" min="1" max="50" required variant="dark"/>
          <b-input-group-append v-b-tooltip.hover title="Приоритет позволяет выполнять шаги с большим значением раньше других инструментов того же этапа. По умолчанию приоритет равен 1, поэтому все шаги обрабатываются одинаково">
            <b-button variant="outline">
              <b-icon icon="info-circle-fill" variant="info"/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <small class="text-muted">Приоритет шага</small>
      </b-form-group>
    </b-form>
    <b-form-group description="Теги">
        <b-form-tags no-outer-focus v-model="tags" placeholder="" remove-on-delete size="md" tag-variant="dark"/>
      </b-form-group>
  </b-modal>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
export default {
  name: 'processModal',
  mixins: [RekonoApi],
  props: {
    id: String,
    process: Object,
    tool: Object,
    initialized: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    edit () {
      return ![null, undefined].includes(this.process)
    },
    title () {
      let title = this.process ? 'Редактировать процесс' : 'Новый процесс'
      if (this.tool) {
        title = `${title} с ${this.tool.name}`
      }
      return title
    },
    button () {
      return this.process ? 'Обновить процесс' : 'Создать процесс'
    }
  },
  data () {
    return {
      name: null,
      description: null,
      configuration: null,
      priority: 1,
      tags: [],
      nameState: null,
      descriptionState: null,
      invalidName: 'Название процесса обязательно',
      invalidDescription: 'Описание процесса обязательно'
    }
  },
  watch: {
    initialized (initialized) {
      if (initialized) {
        if (this.process) {
          this.name = this.process.name
          this.description = this.process.description
          this.tags = this.process.tags
        } else if (this.tool) {
          this.configuration = this.tool.configurations[0].id
        }
      }
    }
  },
  methods: {
    check () {
      const valid = this.$refs.process_form.checkValidity()
      if (!this.validateName(this.name)) {
        this.nameState = false
        this.invalidName = this.name && this.name.length > 0 ? 'Неверное название процесса' : 'Название процесса обязательно'
      }
      if (!this.validateText(this.description)) {
        this.descriptionState = false
        this.invalidDescription = this.description && this.description.length > 0 ? 'Неверное описание процесса' : 'Описание процесса обязательно'
      }
      return valid && this.nameState !== false && this.descriptionState !== false
    },
    confirm (event) {
      event.preventDefault()
      if (this.check()) {
        const operation = this.edit ? this.update() : this.create()
        operation.then(success => this.$emit('confirm', { id: this.id, success: success, reload: true }))
      }
    },
    create () {
      return this.post('/api/processes/', { name: this.name, description: this.description, tags: this.tags }, this.name)
        .then(data => {
          if (!this.tool) {
            this.success(this.name, 'Новый процесс создан успешно')
            return Promise.resolve(true)
          } else {
            return this.post(
              '/api/steps/',
              { process: data.id, tool_id: this.tool.id, configuration_id: this.configuration, priority: this.priority },
              `${this.name} - ${this.tool.name}`,
              'Новый процесс создан успешно'
            )
              .then(() => { return Promise.resolve(true) })
              .catch(() => { return Promise.resolve(false) })
          }
        })
        .catch(() => { return Promise.resolve(false) })
    },
    update () {
      return this.put(
        `/api/processes/${this.process.id}/`,
        { name: this.name, description: this.description, tags: this.tags },
        this.name, 'Процесс обновлён успешно'
      )
        .then(() => { return Promise.resolve(true) })
        .catch(() => { return Promise.resolve(false) })
    },
    clean () {
      this.name = null
      this.description = null
      this.configuration = null
      this.priority = 1
      this.tags = []
      this.nameState = null
      this.descriptionState = null
      this.$emit('clean')
    }
  }
}
</script>
